import { Component, OnInit, EventEmitter } from '@angular/core';
import { DCInput } from './includes/dynamic_components/dynamic.service';
import { IPTVVideoService } from './includes/iptv-video/iptv-video.service';

@Component({
    selector: 'help-window',
    templateUrl: 'help.component.html',
    styleUrls:['help.component.css']
})

export class HelpComponent implements OnInit, DCInput {
    title = "Помощь!";
    destroyEmitter:EventEmitter<null> = new EventEmitter();
    constructor(private _player:IPTVVideoService) { }

    ngOnInit() { }

    close(){
        this.destroyEmitter.emit(null);
    }
    /**
     * Воспроизведение видеоинструкции
     */
    video_instruction(){
        this._player.play("../videoplayer/iptv_editor_help.mp4");
        this._player.title = "Видеоинструкция!";
    }
}